// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.PDP.CompleteYourKitItems.View'
,	[
		'item_relations_cell.tpl',
		'item_relations_row.tpl',
        'facets_items_collection.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
		'c3_shoppingextensions_pdp_completeyourkit_items.tpl',
        'C3.ShoppingExtensions.PDP.CompleteYourKitItems.CellView',
		'Tracker',
		'Utils',
		'C3.ShoppingExtensions.PDP.CompleteYourKitItems.Collection',
		'Backbone.CollectionView',
		'Backbone'
    ]
, function (
	item_relations_cell_tpl,
	item_relations_row_tpl,
    facets_items_collection_tpl,
    facets_items_collection_view_cell_tpl,
    facets_items_collection_view_row_tpl,
	c3_shoppingextensions_completeyourkit_items_tpl,
    CompleteYourKitItemsCellView,
	Tracker,
	Utils,
    CompleteYourKitItemsCollection,
	BackboneCollectionView,
	Backbone
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return BackboneCollectionView.extend({

		initialize: function (options) {

           this.slideWidth = options.slideWidth;
           this.maxSlides = options.maxSlides;
           this.parentItemInfo =  options.parentItemInfo;

		const { siteSettings } = this.options.application.getConfig();
        const is_sca_advanced = siteSettings.sitetype === 'ADVANCED';
        const collection = is_sca_advanced
            ? new CompleteYourKitItemsCollection({ itemsIds: this.options.itemsIds})
            : new Backbone.Collection();

        //console.log(this.options.itemsIds)
        

        var itemIdsLength = collection.itemsIds
         //console.log(itemIdsLength)  
        
        BackboneCollectionView.prototype.initialize.call(this, {
            collection: collection,
            viewsPerRow: Infinity,
            cellTemplate: item_relations_cell_tpl,
            rowTemplate: item_relations_row_tpl,
            childView: CompleteYourKitItemsCellView,
            template: c3_shoppingextensions_completeyourkit_items_tpl,
            childViewOptions: {
                    origin: 'CompleteYourKit-Items-ALL',
                    //hideArrows : itemIdsLength.length <= 4 ? true : false,
                    application : this.options.application,
                    configuration : this.options.configuration,
                    container : this.options.container,
                    parentItemInfo : this.options.parentItemInfo
                }
        });

        this.view_tracked = false;
       // this.loadRelatedItems();
        var self = this;
        /*setTimeout(function() {
            self.selectBTItem();  
        }, 1500); */

            if (is_sca_advanced) {
                this.once('afterCompositeViewRender', this.loadRelatedItems, this);
                //const layout = this.options.application.getLayout();
            }
		},
        events: {
            /*'click [data-action="better-together-item-checkbox"]': 'selectBTItem'*/
            
        },
        loadRelatedItems: function loadRelatedItems() {
        const self = this;

        self.collection.fetchItems().done(function() {
            if (self.collection.length) {
                if (!self.view_tracked) {
                    Tracker.getInstance().trackProductListEvent(
                        self.collection,
                        'Correlated Items'
                    );
                    self.view_tracked = true;
                }
            }

            self.render();

            //if(!Utils.isPhoneDevice())
            //{
            //console.log(self.collection.length)
            setTimeout(function() {
                //if(self.collection.length > 4) //slider if only more than 4
                //{
                    const carousel = self.$el.find('[data-type="carousel-items"]');

                    const {
                        siteSettings,
                        imageSizeMapping,
                        bxSliderDefaults
                    } = self.options.application.getConfig();

                    if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                        const img_min_height = (_.where(siteSettings.imagesizes, {
                            name: imageSizeMapping.thumbnail
                        })[0]).maxheight;

                        carousel
                            .find('.item-relations-related-item-thumbnail')
                            .css('minHeight', img_min_height);
                    }
                    
                    //bxSliderDefaults.slideWidth = 256;
                    bxSliderDefaults.maxSlides = 4;

                    if(self.collection.length >= 6)
                    {
                      bxSliderDefaults.controls = true;  
                      bxSliderDefaults.slideWidth = 230;
                    }
                    else{
                       bxSliderDefaults.slideWidth = 230;
                       bxSliderDefaults.controls = false;  
                    }
                    

                    bxSliderDefaults.hideControlOnEnd = true;
                    bxSliderDefaults.prevText = '<a data-click="left-click" data-action="complete-kit-click" class="pdp-completekit carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                    bxSliderDefaults.nextText = '<a data-click="right-click" data-action="complete-kit-click" class="pdp-completekit carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
            
                    /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
                    bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                *///bxSliderDefaults.touchEnabled = false;
                   //console.log(self.collection.length)
                    bxSliderDefaults.infiniteLoop = false;
                    /*bxSliderDefaults.hideControlOnEnd = true;
                    bxSliderDefaults.auto = false;*/
                    Utils.initBxSlider(carousel, bxSliderDefaults);
                //}
            });
            //}
        });
    }/*,

         destroy: function destroy() {
            this._destroy();
            this.off('afterCompositeViewRender', this.loadRelatedItems, this);
        }*/

	});
});
